// extracted by mini-css-extract-plugin
export default {"headerContainer":"shipmentReport_headerContainer__PK7+9"};